import { render } from "./ProfileClient.vue?vue&type=template&id=34769909&scoped=true"
import script from "./ProfileClient.vue?vue&type=script&lang=js"
export * from "./ProfileClient.vue?vue&type=script&lang=js"

import "./ProfileClient.vue?vue&type=style&index=0&id=34769909&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34769909"]])

export default __exports__